<template>
  <div class="popup-mask" v-show="isShow">
    <div
      class="popup-box"
      v-move="'.title'"
    >
      <div
        class="title"
      >
        {{title}}
        <!-- <i class="el-icon-close" @click="cancel()"></i> -->
        <img class="ic-close" src="@/assets/img/home/cha.png" @click="cancel()">
      </div>

      <div class="content-box">
        <div class="content">
          <slot>
            <div class="content-box_text">
              <p v-html="content"></p>
            </div>
          </slot>
        </div>

        <div class="btn-box" v-show="isbtn">
          <button class="sub" @click="save()" v-show="isbtn === true || isbtn == 'save'">{{saveContent}}</button>
          <button class="cel" @click="cancel()" v-show="isbtn === true || isbtn == 'cancel'">{{cancelContent}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
    };
  },
  props: {
    saveContent: {
      type: String,
      default: '确定',
    },
    cancelContent: {
      type: String,
      default: '取消',
    },
    title: {
      type: String,
      default: '提示',
    },
    content: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
    isbtn: {
      type: [ Boolean, String ],
      default: true,
    },
    cancelFoo: {
      type: Function,
      default: () => {},
    },
    saveFoo: {
      type: Function,
      default: () => {},
    },
    remove: {
      type: Function,
      default: () => {},
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.isShow = this.show
    })
  },
  methods: {
    cancel() {
      this.isShow = false
      this.$emit('update:show', false)
      this.cancelFoo()
      this.$emit('cancel')
      this.remove()
    },
    save() {
      this.isShow = false
      this.$emit('update:show', false)
      this.saveFoo()
      this.$emit('save')
      this.remove()
    },
  },
  watch: {
    show(newV) {
      this.isShow = newV
    },
  },
};
</script>

<style lang='less' scoped>
.popup-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000020;
  font-size: 0;
}
.popup-box {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 110;
  box-sizing: border-box;
  width: 350px;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  background-color: #FFFFFF;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .3);
  .title {
    position: relative;
    height: 50px;
    text-align: center;
    color: #FFFFFF;
    border-radius: 10px 10px 0 0;
    background: #3831FF;
    font-size: 18px;
    font-size: 16px;
    line-height: 50px;
    .el-icon-close {
      position: absolute;
      top: 13px;
      right: 13px;
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #00B7EE;
      font-style: normal;
      line-height: 24px;
      text-align: center;
      cursor: pointer;
    }
    .ic-close {
      position: absolute;
      top: 13px;
      right: 13px;
      display: block;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #00B7EE;
      cursor: pointer;
    }
  }
  .content-box {
    box-sizing: border-box;
    border-radius: 0 0 14px 14px;
    background: #FFFFFF;
    .content {
      min-height: 110px;
      color: #333333;
      font-size: 16px;
    }
    .content-box_text {
      padding: 0 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 110px;
      text-align: center;
      color: #333333;
      font-size: 16px;
      font-weight: 400;
    }
    .btn-box {
      padding: 10px 0 30px;
      text-align: center;
      font-size: 0;
    }
    button {
      height: 40px;
      margin: 0 15px;
      padding: 0 22px;
      cursor: pointer;
      color: #FFFFFF;
      border: none;
      border-radius: 6px;
      font-size: 16px;
      line-height: 40px;
    }
    .sub {
      background: #3170ff;
    }
    .cel {
      background: #efbc00;
    }
  }
}




</style>